//Calendar
import { Calendar } from '@fullcalendar/core/main.esm';
import timeGridPlugin from '@fullcalendar/timegrid';
import caLocale from '@fullcalendar/core/locales/ca';
import esLocale from '@fullcalendar/core/locales/es';

window.agenda = {
    calendar: null,
    init: function(){
        let calendarEl = document.getElementById('calendar');
        if(calendarEl !== null) {
            agenda.calendar = new Calendar(calendarEl, {
                minTime: '06:00:00',
                maxTime: '20:00:00',
                defaultDate: moment().format("YYYY-MM-DD"),
                timeGridEventMinHeight: 37,
                slotEventOverlap: false,
                plugins: [timeGridPlugin],
                defaultView: 'timeGridDay',
                locales: [caLocale, esLocale],
                locale: Lang.getLocale(),
                height: 'auto',
                allDaySlot: false,
                buttonText: {
                    today: Lang.get('messages.today'),
                    month: Lang.get('messages.month'),
                    week: Lang.get('messages.week'),
                    day: Lang.get('messages.day'),
                    list: Lang.get('messages.list')
                },
                header: {
                    left: 'title',
                    center: '',
                    right: 'today prev,next'
                },
                events: function (info, successCallBack, failureCallback) {
                    $.ajax({
                        url: '/ajax/agenda/get',
                        dataType: 'JSON',
                        data: {
                            // our hypothetical feed requires UNIX timestamps
                            start: agenda.parseIsoDatetime(info.start),
                            end: agenda.parseIsoDatetime(info.end)
                        },
                        failure: function () {
                            failureCallback(Lang.get('messages.there_was_an_error_loading_the_events'));
                        },
                        success: function (json) {
                            //Callback
                            successCallBack(json.events);
                        }
                    });
                },
                eventClick: function(info) {
                    info.jsEvent.preventDefault(); // don't let the browser navigate
                    if (info.event.groupId) {
                        let props = info.event._def.extendedProps;
                        agenda.showInfo(info.event.groupId, info.event.title, props);
                    }
                }
            });
            this.calendar.render();
        }
    },
    parseIsoDatetime: function(dtstr) {
        let momentDate = window.moment(dtstr, 'YYYY-MM-DDTHH:mm:ss+-HH:mm:ss');
        return momentDate.format('YYYY-MM-DD')
    },
    showInfo: function(company_id, title, props) {
        Swal.fire({
            title: props.companyName,
            html: '<div class="text-left">'+
                        Lang.get('messages.workplace') + ': '+props.workplaceName + '<br>'+
                        Lang.get('messages.start') + ': '+props.startingTime + '<br>'+
                        Lang.get('messages.end') + ': '+props.endingTime + '<br>'+
                        Lang.get('messages.message') +': '+props.itemMessage+
                   '</div>',
            showCancelButton: true,
            confirmButtonText: Lang.get('messages.go_to_company'),
            cancelButtonText: Lang.get('messages.close')
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.href = '/companies/'+company_id+'/set';
            }
        });
    }
};
